import React, { useState } from "react";
import Navbar from "../Navbar";
import Footer from "../Footer";
import ToyImage1 from "../../assets/toyImage1.png"
import ToyImage2 from "../../assets/toyImage2.png"
import { addDoc, collection } from "firebase/firestore";
import { db } from "../../firebaseConfig";

const HomePage = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (email.length == 0) {
      alert("Please enter email address !")
      return
    }
    setIsSubmitted(false);
    setLoading(true);
    try {
      const formData = {
        email: email,
        timestamp: new Date()
      }
      const docRef = await addDoc(collection(db, "waitList"), formData);
      console.log("Document written with ID: ", docRef.id);
      setIsSubmitted(true);
      setLoading(false);
    } catch (e) {
      setLoading(false);
      console.error("Error adding document: ", e);
    }
    setEmail("");
  };

  return (
    <>
      <Navbar />
      <div className="bg-primary pt-[50px] min-h-screen flex flex-row overflow-hidden p-[12px]">
        <div className="hidden w-[20%] lg:inline-flex p-2">
          <p className="absolute text-sm text-gray-500 top-[210px] left-[50px] -rotate-90">
            Embrace the heritage of Kondapalli
          </p>
        </div>
        <div className="w-full lg:flex justify-center items-center relative ">
          <div
            id="Ellipse27"
            className="absolute bg-ellipse27 blur-3xl h-[326px] w-[326px] z-30 left-[100px] lg:-left-[300px] bottom-[30px] rounded-full"
          ></div>
          <div
            id="Ellipse28"
            className="absolute bg-ellipse28 blur-3xl h-[326px] w-[326px] z-30 -right-[100px] lg:-right-[300px] top-[40px] rounded-full"
          ></div>

          <div className="text-center mt-5 lg:mt-1 mb-2 lg:mb-16">
            <div className="inline-flex items-center justify-center space-x-3 mb-1 lg:mb-5">
              <div className="h-[2px] w-[50px] bg-black"></div>
              <div className="text-lg lg:text-2xl mb-1 lg:mb-2">
                COMING SOON
              </div>
              <div className="h-[2px] w-[50px] bg-black"></div>
            </div>

            <div className="flex flex-col justify-center items-center">
              <div className="font-syne w-full lg:w-[80%] mt-8 lg:mt-16 flex items-center ">
                <p className="text-5xl font-bold md:text-[64px]">
                  <img
                    src={ToyImage1}
                    alt="toy_image"
                    className="inline-block lg:hidden mt-[-30px] w-[41px] h-[67px] rotate-[-11.75deg]"
                  />
                  Get{" "}
                  <img
                    src={ToyImage2}
                    alt="toy_image"
                    className="inline-block mx-1 pt-0 lg:pt-[60px] mt-[-30px] lg:mt-[-160px] w-[41px] lg:w-[152.98px] h-[67px] lg:h-[240.59px] rotate-[11.75deg]"
                  />
                  Notified When We Launch
                </p>
              </div>
              <div className="w-full lg:w-2/3 p-3 mt-1">
                <form onSubmit={handleSubmit}>
                  <input
                    type="email"
                    placeholder="Enter Your Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full bg-primary rounded-full p-3 pr-10 border border-gray-300 mb-4"
                  />
                  <button
                    type="submit"
                    disabledc={loading}
                    className="absolute z-50 ml-[-110px] lg:ml-[-115px] mt-[5px] bg-orange-500 hover:bg-orange-600 text-white font-bold py-2 px-4 rounded-full"
                  >
                    Notify Me
                  </button>
                </form>
                {
                  loading ?
                    <p className="text-green-700">Submitting Details...</p>
                    : null}

                {isSubmitted ? <p className="text-green-700">Thanks! We will notify you once we are live.</p> : null}
              </div>
              <div className="mt-1">
                <p className="text-xs lg:text-sm">
                  We're currently working on creating something fantastic
                </p>
                <p className="text-xs lg:text-sm">
                  We'll be here soon, subscribe to be notified
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="lg:block w-[20%] hidden p-2 ">
          <p className="text-sm text-gray-500 text-center">@2025 </p>
          <p className="absolute bottom-[250px] right-[60px] text-sm text-gray-500 text-right rotate-90">
            Experience the Magic of Handmade Artistry
          </p>
        </div>
        <Footer />
      </div>

    </>
  );
};

export default HomePage;
